// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropzone[data-v-0a9a9189] .dz-message {\n\tpadding-top: 27.125%;\n\tline-height: 1;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tmargin: 0;\n}\n.is-active[data-v-0a9a9189] .dz-message {\n\tpadding: 29.125% 18%;\n}\n", ""]);
// Exports
module.exports = exports;
